
const RecipeIntro = () => {
  return (
    <div className="grid md:grid-cols-2 gap-8 items-center mb-12">
      <div>
        <p className="text-muted-foreground mb-4">
          Fortune cookies are iconic treats that have become synonymous with Chinese restaurants in America. While they may seem complex to make, with the right technique and a bit of practice, you can create these delicate, crispy cookies at home—complete with your own personalized fortunes!
        </p>
        <p className="text-muted-foreground">
          This recipe yields approximately 12-15 cookies that are just like the ones you'd receive at your favorite restaurant. They're delicately flavored with vanilla and almond, with the perfect amount of sweetness.
        </p>
      </div>
      <div className="bg-muted rounded-xl overflow-hidden">
        <img 
          src="/lovable-uploads/52720b64-5ddc-435c-b502-343d03269436.png" 
          alt="Homemade fortune cookies with personalized fortunes" 
          className="w-full h-auto object-cover"
        />
      </div>
    </div>
  );
};

export default RecipeIntro;
